var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductsDigitalproducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.36914 13.3643C8.36914 11.1551 10.16 9.36426 12.3691 9.36426H29.7263C31.9354 9.36426 33.7263 11.1551 33.7263 13.3643V24.684C33.7263 26.8931 31.9354 28.684 29.7263 28.684H12.3691C10.16 28.684 8.36914 26.8931 8.36914 24.684V13.3643Z",
    fill: "#6059FF",
    stroke: "#6059FF",
    strokeWidth: 1.9318
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2868 17.2087L19.8921 14.5522C18.5591 13.7464 16.8574 14.7062 16.8574 16.2637V21.8679C16.8574 23.4068 18.5228 24.3692 19.8562 23.6007L24.6019 20.8653C25.9209 20.105 25.9407 18.2085 24.6378 17.4209L24.2868 17.2087Z",
    fill: "#FFD8D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8555 21.8966C28.8555 19.1352 31.094 16.8966 33.8555 16.8966H46.1832L52.8236 16.8965V21.039C52.8236 24.3926 55.5725 27.0951 58.9256 27.0381L63.511 26.9602V50.6036C63.511 53.3651 61.2724 55.6036 58.511 55.6036H33.8555C31.094 55.6036 28.8555 53.3651 28.8555 50.6036V21.8966Z",
    fill: "#8984FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3169 25.0742V19.232L60.3384 26.4897H54.7324C53.9507 26.4897 53.3169 25.856 53.3169 25.0742Z",
    fill: "#FFD8D6",
    stroke: "#FFD8D6",
    strokeWidth: 1.16904,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1162 36.25H43.6683H51.2205",
    stroke: "#FFD8D6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1162 43.5391H41.2102H46.3042",
    stroke: "#FFD8D6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0127 38.3516C3.0127 36.1424 4.80356 34.3516 7.0127 34.3516H19.3525C21.5617 34.3516 23.3525 36.1424 23.3525 38.3516V50.6914C23.3525 52.9005 21.5617 54.6914 19.3525 54.6914H7.0127C4.80356 54.6914 3.0127 52.9005 3.0127 50.6914V38.3516Z",
    fill: "#8984FF",
    stroke: "#8984FF",
    strokeWidth: 1.9318
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8741 41.9672L6.28959 46.384C6.09394 46.5725 5.9834 46.8324 5.9834 47.1041V47.8521C5.9834 50.0613 7.77426 51.8522 9.9834 51.8522H16.3743C18.5834 51.8522 20.3743 50.0613 20.3743 47.8522V45.2418C20.3743 44.9701 20.2638 44.7101 20.0681 44.5216L18.4906 43.0019C18.1033 42.6288 17.4903 42.6288 17.103 43.0019L15.9132 44.1482C15.5259 44.5213 14.9128 44.5213 14.5255 44.1482L13.3936 43.0577L12.2617 41.9672C11.8744 41.5941 11.2614 41.5941 10.8741 41.9672Z",
    fill: "#FFD8D6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8285 16.9463H46.0475H33.7374C30.9691 16.9463 28.7276 19.1956 28.7374 21.9639L28.8416 51.557C28.8513 54.3116 31.087 56.5394 33.8416 56.5394H57.5342C60.2957 56.5394 62.5342 54.3009 62.5342 51.5394V27.0069",
    stroke: "#F1F0FF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsDigitalproducts);
export default __webpack_public_path__ + "static/media/products-digitalproducts.c310b1ceb8dc5522c662a7d6a54f3bb6.svg";
export { ForwardRef as ReactComponent };